export const customerColumns = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'phoneNumber', label: 'Phone' },
  {
    key: 'status',
    label: 'Status',
    render: (isActive) => (
      <span className={`font-medium ${isActive ? 'text-[#009E42]' : 'text-[#9E0000]'}`}>
        {isActive ? 'Active' : 'Suspended'}
      </span>
    ),
  },
]

export const adminSupportTicketColumns = [
  { key: 'id', label: 'ID' },
  {
    key: 'usertype',
    label: 'Type',
    render: (value) => <span className={typeColors[value] || ''}>{value}</span>,
  },
  { key: 'phone', label: 'Phone' },
  { key: 'userName', label: 'User Name' },
  { key: 'date', label: 'Date' },
  {
    key: 'status',
    label: 'Status',
    render: (value) => (
      <span
        className={statusColors[value] || ''}
        style={{ textTransform: 'capitalize', fontWeight: 500 }}
      >
        {value}
      </span>
    ),
  },
]

export const statusColors = {
  'resolved': 'text-[#009E42]',
  'in progress': 'text-[#0A78DF]',
  'pending': 'text-[#D10707]',
  'Pending': 'text-[#D10707]',
  'Resolved': 'text-[#009E42]',
  'In Progress': 'text-[#0A78DF]',
}

export const typeColors = {
  product: ' text-gray-600',
  retailer: 'text-blue-600',
  wholeseller: ' text-red-600',
  customer: ' text-green-600',
  product_finder: ' text-yellow-600',
}
